export const GET_ACTIVITY_LOG_AUTHORIZATION_ALL_REQUEST = 'GET_ACTIVITY_LOG_AUTHORIZATION_ALL_REQUEST';
export const GET_ACTIVITY_LOG_AUTHORIZATION_ALL_SUCCESS = 'GET_ACTIVITY_LOG_AUTHORIZATION_ALL_SUCCESS';
export const GET_ACTIVITY_LOG_AUTHORIZATION_ALL_FAILURE = 'GET_ACTIVITY_LOG_AUTHORIZATION_ALL_FAILURE';

export const GET_ACTIVITY_LOG_AUTHORIZATION_FILE_REQUEST = 'GET_ACTIVITY_LOG_AUTHORIZATION_FILE_REQUEST';
export const GET_ACTIVITY_LOG_AUTHORIZATION_FILE_SUCCESS = 'GET_ACTIVITY_LOG_AUTHORIZATION_FILE_SUCCESS';
export const GET_ACTIVITY_LOG_AUTHORIZATION_FILE_FAILURE = 'GET_ACTIVITY_LOG_AUTHORIZATION_FILE_FAILURE';

export const GET_ACTIVITY_LOG_VOUCHER_REQUEST = 'GET_ACTIVITY_LOG_VOUCHER_REQUEST';
export const GET_ACTIVITY_LOG_VOUCHER_SUCCESS = 'GET_ACTIVITY_LOG_VOUCHER_SUCCESS';
export const GET_ACTIVITY_LOG_VOUCHER_FAILURE = 'GET_ACTIVITY_LOG_VOUCHER_FAILURE';

export const GET_ACTIVITY_LOG_EXPENSE_REQUEST = 'GET_ACTIVITY_LOG_EXPENSE_REQUEST';
export const GET_ACTIVITY_LOG_EXPENSE_SUCCESS = 'GET_ACTIVITY_LOG_EXPENSE_SUCCESS';
export const GET_ACTIVITY_LOG_EXPENSE_FAILURE = 'GET_ACTIVITY_LOG_EXPENSE_FAILURE';

export const GET_ACTIVITY_LOG_RECURRING_PAYABLE_REQUEST = 'GET_ACTIVITY_LOG_RECURRING_PAYABLE_REQUEST';
export const GET_ACTIVITY_LOG_RECURRING_PAYABLE_SUCCESS = 'GET_ACTIVITY_LOG_RECURRING_PAYABLE_SUCCESS';
export const GET_ACTIVITY_LOG_RECURRING_PAYABLE_FAILURE = 'GET_ACTIVITY_LOG_RECURRING_PAYABLE_FAILURE';

export const GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_REQUEST = 'GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_REQUEST';
export const GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_SUCCESS = 'GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_SUCCESS';
export const GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_FAILURE = 'GET_ACTIVITY_LOG_SURVEY_CONFIGURATION_FAILURE';

export const GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_REQUEST = 'GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_REQUEST';
export const GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_SUCCESS = 'GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_SUCCESS';
export const GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_FAILURE = 'GET_ACTIVITY_LOG_TEMPLATE_CONFIGURATION_FAILURE';

export const GET_ACTIVITY_LOG_VENDOR_REQUEST = 'GET_ACTIVITY_LOG_VENDOR_REQUEST';
export const GET_ACTIVITY_LOG_VENDOR_SUCCESS = 'GET_ACTIVITY_LOG_VENDOR_SUCCESS';
export const GET_ACTIVITY_LOG_VENDOR_FAILURE = 'GET_ACTIVITY_LOG_VENDOR_FAILURE';

export const GET_ACTIVITY_LOG_CLIENT_REQUEST = 'GET_ACTIVITY_LOG_CLIENT_REQUEST';
export const GET_ACTIVITY_LOG_CLIENT_SUCCESS = 'GET_ACTIVITY_LOG_CLIENT_SUCCESS';
export const GET_ACTIVITY_LOG_CLIENT_FAILURE = 'GET_ACTIVITY_LOG_CLIENT_FAILURE';


